<div *ngFor="let message of alertMessageService.messages" [ngClass]="alertCssClass(message)" class="alert alert-dismissible fade show" role="alert">
    <div [innerHTML]="message.text"></div>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="alertMessageService.remove(message)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
